import {createContext} from "react";
import {IPagarMeApiContext} from "./interfaces/IPagarMeApiContext";

const PagarMeApiContext = createContext<IPagarMeApiContext | undefined>(undefined);
export  default PagarMeApiContext;